import React from "react";

const ViewConcession = ({
  isOpen,
  onClose,
  selectedVoucher
}) => {
    if (!isOpen || !selectedVoucher) return null;
    
    const reward = selectedVoucher?.reward_amount || selectedVoucher?.reward || "0.00";
    const code = selectedVoucher?.code || "-";
    
    const hasValidity = selectedVoucher?.start_date && selectedVoucher?.end_date;
    const validityText = hasValidity
      ? `This voucher is valid from ${new Date(selectedVoucher.start_date).toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
          day: "numeric",
        })} to ${new Date(selectedVoucher.end_date).toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
          day: "numeric",
        })}.`
      : "This voucher is active and ready for use.";

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50" onClick={onClose}>
            <div className="bg-gray-900 p-6 rounded-lg w-96 text-white shadow-xl" onClick={(e) => e.stopPropagation()}>
                {/* Title */}
                <h2 className="text-lg font-semibold mb-4">Concession Details</h2>

                {/* Options */}
                <div className="flex flex-col gap-3 mb-6">
                    <p>Get £{reward} Discount</p>
                    <p>Use Code {code} to avail rewards</p>
                    <p>--------------------------------------------------</p>
                    <p>{validityText}</p>
                </div>
            </div>
        </div>
    );
};

export default ViewConcession;
